import moment from "moment";

export function formatDate(dateString) {
    var createdDate = moment(dateString.split("T")[0]);
    var currentDate = moment();

    var diffDays = currentDate.diff(createdDate, 'days');

    var formattedDate;

    if (diffDays === 0) {
        formattedDate = "today";
    } else if (diffDays === 1) {
        formattedDate = "yesterday";
    } else if (diffDays < 7) {
        formattedDate = diffDays + " days ago";
    } else {
        var diffMonths = currentDate.diff(createdDate, 'months');
        formattedDate = diffMonths + " months ago";
    }

    return formattedDate;
}


